"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.relationMissAttributeRule = void 0;
exports.getMissingAttributeRelations = getMissingAttributeRelations;
const utils_1 = require("@azimutt/utils");
const database_1 = require("../../database");
const databaseUtils_1 = require("../../databaseUtils");
const rule_1 = require("../rule");
const ruleId = 'relation-miss-attribute';
const ruleName = 'attribute not found in relation';
const ruleDescription = 'relations with an attribute not found in the entities';
const CustomRuleConf = rule_1.RuleConf.extend({
    ignores: database_1.AttributeId.array().optional(),
}).strict().describe('RelationMissAttributeConf');
exports.relationMissAttributeRule = {
    id: ruleId,
    name: ruleName,
    description: ruleDescription,
    conf: { level: rule_1.RuleLevel.enum.high },
    zConf: CustomRuleConf,
    analyze(conf, now, db, queries, history, reference) {
        const relIgnores = reference.map(r => r.extra?.relation ? (0, databaseUtils_1.relationToRef)(r.extra?.relation) : undefined).filter(utils_1.isNotUndefined);
        const attrIgnores = conf.ignores?.map(databaseUtils_1.attributeRefFromId) || [];
        const entities = (0, utils_1.indexBy)(db.entities || [], databaseUtils_1.entityToId);
        return (db.relations || [])
            .map(r => getMissingAttributeRelations(r, entities))
            .filter(utils_1.isNotUndefined)
            .filter(v => !relIgnores.some(i => (0, databaseUtils_1.relationRefSame)(i, (0, databaseUtils_1.relationToRef)(v.relation))))
            .map(v => ({ ...v, missingAttrs: v?.missing?.filter(a => !attrIgnores.some(i => (0, databaseUtils_1.attributeRefSame)(i, a))) }))
            .filter(v => v.missingAttrs.length > 0)
            .map(violation => {
            const { attribute, ...entity } = violation.missingAttrs[0];
            return {
                ruleId,
                ruleName,
                ruleLevel: conf.level,
                message: `Relation ${relationName(violation.relation)}, not found attributes: ${violation.missingAttrs.map(databaseUtils_1.attributeRefToId).join(', ')}`,
                entity,
                attribute,
                extra: violation
            };
        });
    }
};
const relationName = (r) => r.name || (0, databaseUtils_1.relationToId)(r);
function getMissingAttributeRelations(relation, entities) {
    const src = entities[(0, databaseUtils_1.entityRefToId)(relation.src)];
    const ref = entities[(0, databaseUtils_1.entityRefToId)(relation.ref)];
    if (!src || !ref) {
        return undefined;
    }
    const attrs = (0, utils_1.zip)(relation.src.attrs, relation.ref.attrs).map(([srcAttr, refAttr]) => ({
        src: srcAttr,
        srcAttr: (0, databaseUtils_1.getAttribute)(src.attrs, srcAttr),
        ref: refAttr,
        refAttr: (0, databaseUtils_1.getAttribute)(ref.attrs, refAttr),
    }));
    const missing = attrs.flatMap(attr => [
        attr.srcAttr ? undefined : { ...(0, databaseUtils_1.relationLinkToEntityRef)(relation.src), attribute: attr.src },
        attr.refAttr ? undefined : { ...(0, databaseUtils_1.relationLinkToEntityRef)(relation.ref), attribute: attr.ref },
    ].filter(utils_1.isNotUndefined));
    return missing.length > 0 ? { relation, missing } : undefined;
}
//# sourceMappingURL=relationMissAttribute.js.map